import { Link, useLocation } from "react-router-dom";
import { UserGroupIcon, UserIcon } from "@heroicons/react/24/outline";
import { classNames } from "../../utils/classNamesUtils";
import { useTranslation } from "react-i18next";

export function SettingsLayout({ children }: any) {
    const { t } = useTranslation();
    const location = useLocation();
    const subNavigation = [
        { name: t('settings.company'), href: "/setting/company", icon: UserGroupIcon, current: location.pathname === "/setting/company" },
        { name: t('settings.profile'), href: "/setting/profile", icon: UserIcon, current: location.pathname === "/setting/profile" },
    ];

    return (
        <div>
            <header className="relative py-5">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold tracking-tight text-black">{t('settings.settings')}</h1>
                </div>
            </header>
            <main className="relative pt-4">
                <div className="mx-auto max-w-screen-xl px-4 pb-6 sm:px-6 lg:px-8 lg:pb-16">
                    <div className="overflow-hidden rounded-lg bg-white shadow">
                        <div className="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
                            <aside className="py-6 lg:col-span-3">
                                <nav className="space-y-1">
                                    {subNavigation.map((item, i) => (
                                        <Link
                                            key={i}
                                            to={item.href}
                                            className={classNames(
                                                item.current
                                                    ? "bg-indigo-50 border-indigo-500 text-indigo-700 hover:bg-indigo-50 hover:text-indigo-700"
                                                    : "border-transparent text-gray-900 hover:bg-gray-50 hover:text-gray-900",
                                                "group border-l-4 px-3 py-2 flex items-center text-sm font-medium"
                                            )}
                                            aria-current={item.current ? "page" : undefined}
                                        >
                                            <item.icon
                                                className={classNames(
                                                    item.current
                                                        ? "text-indigo-500 group-hover:text-indigo-500"
                                                        : "text-gray-400 group-hover:text-gray-500",
                                                    "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                                                )}
                                                aria-hidden="true"
                                            />
                                            <span className="truncate">{item.name}</span>
                                        </Link>
                                    ))}
                                </nav>
                            </aside>

                            <div className="divide-y divide-gray-200 lg:col-span-9">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}